import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";

export const isDefinedFilterDefault = (value: unknown): value is NonNullable<unknown> =>
    value !== undefined && value !== null;

type FilterWithEmptyValue = {
    readonly key: PropertyKey;
    readonly filter: { getEmptyValue(): unknown };
};

/** Collects non-null `getEmptyValue()` results keyed by filter instance key (flat). */
export const collectFlatFilterDefaults = <T extends IPlainObject>(
    instances: readonly FilterWithEmptyValue[],
): Partial<T> => {
    const result: Record<string, unknown> = {};

    for (const { key, filter } of instances) {
        const initialValue = filter.getEmptyValue();
        if (isDefinedFilterDefault(initialValue) && key) {
            result[String(key)] = initialValue;
        }
    }

    return result as Partial<T>;
};
